import type {
  UpdateManagementPayload,
  UpdateManagementResponse,
} from '@/domains/academicRisk/academicRiskManagement.entity';
import type { AcademicRiskManagementRepository } from '@/domains/academicRisk/academicRiskManagement.repository';

/**
 * Use Case para actualizar una gestión de riesgo académico existente
 *
 * Responsabilidades:
 * - Validar y ejecutar la actualización de gestiones de riesgo académico
 * - Coordinar con el repositorio para persistir las modificaciones
 */
export class UpdateAcademicRiskManagementUseCase {
  private repository: AcademicRiskManagementRepository;

  /**
   * Inicializa el UseCase con el repositorio necesario
   * @param repository - Repositorio para operaciones de gestión de riesgo académico
   */
  constructor(repository: AcademicRiskManagementRepository) {
    this.repository = repository;
  }

  /**
   * Ejecuta la actualización de una gestión de riesgo académico
   * @param cod_ejecucion - Código de ejecución de la gestión a actualizar
   * @param payload - Datos de la gestión a actualizar
   * @throws Error si la actualización falla
   */
  async execute(
    cod_ejecucion: number,
    payload: UpdateManagementPayload,
  ): Promise<UpdateManagementResponse> {
    return await this.repository.updateManagement(cod_ejecucion, payload);
  }
}
